import React, { createContext, useRef, useState, useEffect } from "react";
import { resourcesHelper } from "../utils/helper";

const defaultState = {};

const AppContext = createContext(defaultState);

const AppProvider = ({ children }) => {
  const headerRef = useRef(null);
  const stickyIsiRef = useRef(null);
  const isiRef = useRef(null);
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const [showExitModal, setShowExitModal] = useState(false);
  const [exitUrl, setExitUrl] = useState("");

	// Resources state
	const [resources, setResources] = useState([]);
	const [filteredResources, setFilteredResources] = useState([]);
	const [resourceFilters, setResourceFilters] = useState({
		Speciality: ["All"],
		Type: [],
		Topic: []
	});

	// Apply filters effect
	useEffect(() => {
		if (resources.length > 0) {
			applyResourceFilters();
		}
	}, [resourceFilters, resources]);

	// Function to set initial resources
	const initResources = (initialResources) => {
		setResources(initialResources);
		resourcesHelper.setResources(initialResources);
	};

	// Function to apply filters to resources
	const applyResourceFilters = () => {
		if (!resources || resources.length === 0) return;

		try {
			// Clone resources to avoid direct mutation
			const filtered = [...resources];

			// Safely apply filters
			if (typeof resourcesHelper?.filterData === 'function') {
				const filteredData = resourcesHelper.filterData(resourceFilters, filtered);

				if (Array.isArray(filteredData)) {
					setFilteredResources(filteredData);
				}
			}
		} catch (error) {
			console.error('Error filtering resources:', error);
		}
	};

	// Function to update resource filters
	const updateResourceFilters = (newFilters) => {
		// Set the new filters
		setResourceFilters(prev => {
			// Create a new object to ensure React detects the change
			return { ...prev, ...newFilters };
		});
	};

	// Exit modal functions
  const openExitModal = (url) => {
    setExitUrl(url);
    setShowExitModal(true);
  };

  const closeExitModal = () => {
	  setShowExitModal(false);
  };

  const store = {
    headerRef,
    stickyIsiRef,
    isiRef,
    isHeaderVisible,
    setIsHeaderVisible,
    showExitModal,
    exitUrl,
    openExitModal,
    closeExitModal,
	  // Resources related
	  resources,
	  filteredResources,
	  resourceFilters,
	  initResources,
	  updateResourceFilters
  };

  return <AppContext.Provider value={store}>{children}</AppContext.Provider>;
};

export { AppProvider };
export default AppContext;

